import { ReactNode } from "react";

import { Backdrop } from "~/ui/base/Backdrop.tsx";
import { Layer } from "~/ui/provider/StackedLayerProvider.tsx";

export const WebStackedPage = ({
  children,
  close,
  descriptionId,
  titleId,
  visible,
}: Omit<Parameters<Layer>[0], "context"> & {
  children: ReactNode;
}) => {
  return (
    <Backdrop
      close={close}
      descriptionId={descriptionId}
      titleId={titleId}
      visible={visible}
    >
      <div
        className={`pointer-events-none fixed inset-0 z-40 flex items-center justify-center overflow-y-auto p-3 sm:p-4 ${
          visible ? "animate-stacked-layer-from" : "animate-stacked-layer-to"
        }`}
      >
        <div className="pointer-events-auto max-h-[90vh] w-full max-w-xl overflow-y-auto rounded-2xl bg-white shadow-2xl sm:rounded-3xl dark:bg-zinc-950">
          {children}
        </div>
      </div>
    </Backdrop>
  );
};

export const createWebStackedPage = (Content: Layer): Layer => {
  const Component = (({ close, context, descriptionId, titleId, visible }) => (
    <WebStackedPage
      close={close}
      descriptionId={descriptionId}
      titleId={titleId}
      visible={visible}
    >
      <Content
        close={close}
        context={context}
        descriptionId={descriptionId}
        titleId={titleId}
        visible={visible}
      />
    </WebStackedPage>
  )) satisfies Layer;
  return Component;
};
